import { render, staticRenderFns } from "./KnowledgeFeedForm.vue?vue&type=template&id=441c2d4b&scoped=true&"
import script from "./KnowledgeFeedForm.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFeedForm.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeFeedForm.vue?vue&type=style&index=0&id=441c2d4b&scoped=true&lang=css&"
import style1 from "./KnowledgeFeedForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c2d4b",
  null
  
)

export default component.exports